import { CatSkeenBox } from './styles';

type Props = {
    catId: string;
}

export const CatSkeen = (props: Props) => {
    return (
        <CatSkeenBox $catId={props.catId} />
    )
}
